import { __spreadArray } from 'tslib';
import React, { useState } from 'react';
import styles from './NavBar.module.css.js';
import { RippleButton } from '../RippleButton/RippleButton.js';
import { useTheme } from '../../hooks/theme/theme.js';

var NavBar = function NavBar(_a) {
  var logoLight = _a.logoLight,
      logoDark = _a.logoDark,
      leftLinks = _a.leftLinks,
      rightLinks = _a.rightLinks,
      _b = _a.primaryButtonText,
      primaryButtonText = _b === void 0 ? 'Download App' : _b,
      buttonOnClick = _a.buttonOnClick,
      logoOnClick = _a.logoOnClick;
  var leftLinksItems = leftLinks === null || leftLinks === void 0 ? void 0 : leftLinks.map(function (item) {
    return /*#__PURE__*/React.createElement("button", {
      className: styles['navbar-link'],
      type: "button",
      "aria-label": item.title,
      onClick: item.onClick,
      key: item.title
    }, item.title);
  });
  var rightLinksItems = rightLinks === null || rightLinks === void 0 ? void 0 : rightLinks.map(function (item) {
    return /*#__PURE__*/React.createElement("button", {
      className: styles['navbar-link'],
      type: "button",
      "aria-label": item.title,
      onClick: item.onClick,
      key: item.title
    }, item.title);
  });
  var sideLinks = rightLinks === null || rightLinks === void 0 ? void 0 : rightLinks.concat(leftLinks || []);
  var sideLinksItems = (sideLinks === null || sideLinks === void 0 ? void 0 : sideLinks.length) ? __spreadArray([/*#__PURE__*/React.createElement("button", {
    className: styles['navbar-side-link'],
    type: "button",
    "aria-label": primaryButtonText,
    onClick: buttonOnClick,
    key: primaryButtonText
  }, primaryButtonText)], sideLinks.map(function (item) {
    return /*#__PURE__*/React.createElement("button", {
      className: styles['navbar-side-link'],
      type: "button",
      "aria-label": item.title,
      onClick: item.onClick,
      key: item.title
    }, item.title);
  }), true) : [/*#__PURE__*/React.createElement("button", {
    className: styles['navbar-side-link'],
    type: "button",
    "aria-label": primaryButtonText,
    onClick: buttonOnClick,
    key: primaryButtonText
  }, primaryButtonText)];

  var _c = useState(true),
      collapseStatus = _c[0],
      setCollapseStatus = _c[1];

  var collapse = function collapse() {
    setCollapseStatus(!collapseStatus);
  }; // @ts-ignore


  var theme = useTheme().theme;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['navbar-grid']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['navbar-background']
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": "home",
    onClick: function onClick(e) {
      return logoOnClick(e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['navbar-logo-container']
  }, theme === 'light' ? logoLight : logoDark)), /*#__PURE__*/React.createElement("div", null, leftLinksItems), /*#__PURE__*/React.createElement("div", null, rightLinksItems), /*#__PURE__*/React.createElement("div", null, primaryButtonText && /*#__PURE__*/React.createElement(RippleButton, {
    primary: true,
    label: primaryButtonText,
    onClick: buttonOnClick,
    size: "small"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: [styles['navbar-collapse-button'], collapseStatus ? '' : styles['navbar-collapse-button-open']].join(' '),
    onClick: function onClick() {
      return collapse();
    },
    type: "button",
    "aria-label": "menu-button"
  }, /*#__PURE__*/React.createElement("i", null))), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    className: [styles['navbar-side'], collapseStatus ? '' : styles['navbar-side-open']].join(' ')
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['navbar-logo-container']
  }, theme === 'light' ? logoLight : logoDark), /*#__PURE__*/React.createElement("div", {
    className: styles['navbar-side-line']
  }), /*#__PURE__*/React.createElement("div", null, sideLinksItems)), /*#__PURE__*/React.createElement("div", {
    className: [styles['navbar-collapse-overlay'], collapseStatus ? '' : styles['navbar-collapse-overlay-open']].join(' ')
  }));
};

export { NavBar };
//# sourceMappingURL=NavBar.js.map
